/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
/**
 * EmailMsgResourceApi - axios parameter creator
 * @export
 */
export const EmailMsgResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für das ActionItemEmail eine MSG-Datei erstellt.-</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Abrufen einer Msg-Datei für Outlook.
         * @param {string} planID PlanId vom Verfahren
         * @param {string} actionItemEmailID actionItemEmailID vom ActionItemEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMsgFile: async (planID: string, actionItemEmailID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('createMsgFile', 'planID', planID)
            // verify required parameter 'actionItemEmailID' is not null or undefined
            assertParamExists('createMsgFile', 'actionItemEmailID', actionItemEmailID)
            const localVarPath = `/verfahren/{planID}/emailMsg/{actionItemEmailID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"actionItemEmailID"}}`, encodeURIComponent(String(actionItemEmailID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailMsgResourceApi - functional programming interface
 * @export
 */
export const EmailMsgResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailMsgResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für das ActionItemEmail eine MSG-Datei erstellt.-</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Abrufen einer Msg-Datei für Outlook.
         * @param {string} planID PlanId vom Verfahren
         * @param {string} actionItemEmailID actionItemEmailID vom ActionItemEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMsgFile(planID: string, actionItemEmailID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMsgFile(planID, actionItemEmailID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailMsgResourceApi.createMsgFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailMsgResourceApi - factory interface
 * @export
 */
export const EmailMsgResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailMsgResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für das ActionItemEmail eine MSG-Datei erstellt.-</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
         * @summary Endpunkt zum Abrufen einer Msg-Datei für Outlook.
         * @param {string} planID PlanId vom Verfahren
         * @param {string} actionItemEmailID actionItemEmailID vom ActionItemEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMsgFile(planID: string, actionItemEmailID: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createMsgFile(planID, actionItemEmailID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailMsgResourceApi - object-oriented interface
 * @export
 * @class EmailMsgResourceApi
 * @extends {BaseAPI}
 */
export class EmailMsgResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für das ActionItemEmail eine MSG-Datei erstellt.-</p><p><b>Benötigte Rechte:</b> VERFAHRENSSTEUERUNG_WRITE or ADMIN</p>
     * @summary Endpunkt zum Abrufen einer Msg-Datei für Outlook.
     * @param {string} planID PlanId vom Verfahren
     * @param {string} actionItemEmailID actionItemEmailID vom ActionItemEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailMsgResourceApi
     */
    public createMsgFile(planID: string, actionItemEmailID: string, options?: RawAxiosRequestConfig) {
        return EmailMsgResourceApiFp(this.configuration).createMsgFile(planID, actionItemEmailID, options).then((request) => request(this.axios, this.basePath));
    }
}

